import React from 'react'

export default function ItemQuantity (props) {
  if (!props.value) return null

  return (
    <div className='shop-cart-row__name'>
      <a className='shop-cart-row__controll shop-cart-row__controll--left' onClick={props.onClickMinus}>&ndash;</a>
      <div className='shop-cart-row__count'>{`(${props.value})`}</div>
      <div className='shop-cart-row__title'>&nbsp;{ props.title }</div>
      <a className='shop-cart-row__controll shop-cart-row__controll--right' onClick={props.onClickPlus}>+</a>
    </div>
  )
}
